<script setup lang="ts">
import type { GetAddressesResponseItem } from '@vue-storefront/prestashop-api';
defineProps<GetAddressesResponseItem>();
</script>

<template>
  <div class="flex">
    <span class="flex flex-1">
      <span class="flex flex-col">
        <span id="delivery-method-0-label" class="block font-semibold text-base mb-1 text-gray-800">{{ alias }}</span>
        <span id="delivery-method-0-label" class="block sm:text-sm font-medium text-gray-900">{{ firstname }} {{ lastname }}</span>
        <span id="delivery-method-0-label" class="block sm:text-sm font-medium text-gray-900">{{ address1 }}</span>
        <span id="delivery-method-0-label" class="block sm:text-sm font-medium text-gray-900">{{ phone }}</span>
        <span id="delivery-method-0-label" class="block sm:text-sm font-medium text-gray-900">{{ postcode }}</span>
        <span id="delivery-method-0-label" class="block sm:text-sm font-medium text-gray-900">{{ city }}</span>
      </span>
    </span>
  </div>
</template>
